import { useState } from 'react';
import { Button, Grid, Message } from 'semantic-ui-react';
import { Icon } from 'semantic-ui-react';
import 'neo-react-semantic-ui-range/dist/styles.min.css'
import './ObjectsStep.scss';
import {v4 as uuidv4} from 'uuid';
import { StepType } from '../../CreateProjectWizard';
import CreateUpdateObjectModal from './components/CreateUpdateObjectModal/CreateUpdateObjectModal';
import HistoryObject from '../../../../../../structures/historyObject';
import Place from '../../../../../../structures/place';
import api from '../../../../../../utils/api';
import GeneratedImage from '../../../../../../shared/GeneratedImage/GeneratedImage';

interface ObjectsStepProps{
    description: string
    setStep: React.Dispatch<React.SetStateAction<StepType>>
    objects: HistoryObject[]
    setObjects: React.Dispatch<React.SetStateAction<HistoryObject[]>>
}

function ObjectsStep({description, setStep, objects, setObjects}: ObjectsStepProps) {
    const [openCreateUpdateModal, setOpenCreateUpdateModal] = useState(false);
    const [createUpdateModalObject, setCreateUpdateModalObject] = useState<Place|undefined>(undefined);
    const [isInventing, setIsInventing] = useState(false);

    const invent = async () => {
        setObjects([]);
        setIsInventing(true);
        
        let objects = (await api.inventObjectsForHistory(description)).map(name => new Place(uuidv4(), name, 'Ещё придумываю...'));
        setObjects(objects);
        await Promise.all(objects.map(async (place, index) => {
            let placeDescription = await api.inventDescriptionForObject(place.name, description);
            place.description = placeDescription;
            setObjects(old => {
                let newObjects = [...old];
                newObjects[index].description = placeDescription;
                return newObjects;
            });
            return null;
        }));
        let promts = await Promise.all(objects.map((object, index) => api.inventPromtForObjectPhoto(object)));
        setObjects(old => {
            let newObjects = [...old];
            for(let i = 0; i < newObjects.length; i++) {
                newObjects[i].promtForPhoto = promts[i];
            }
            return newObjects;
        });
        setIsInventing(false);
    };
    return <>
        <div className='objects'>
            {objects.length === 0 && <Button icon fluid onClick={invent} ><Icon name='magic'/> Придумать предметы</Button>}
            {objects.length !== 0 && !isInventing && <Button icon fluid onClick={invent} ><Icon name='magic'/> Придумать другие предметы</Button>}
            {isInventing ? <Message>Придумываю...</Message> : ''}
            {objects.map((object, index) => {
                return <div className='item' onClick={() => {
                    setCreateUpdateModalObject(object);
                    setOpenCreateUpdateModal(true);
                }}>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={2}>
                                {object.promtForPhoto != null && object.promtForPhoto !== undefined && object.promtForPhoto !== '' ? 
                                <GeneratedImage key={index} promt={object.promtForPhoto} imageId={object.imageId} onGetId={(promt, id) => {
                                    setObjects(old => {
                                        let newMembers = [...old];
                                        newMembers.filter(x=> x.promtForPhoto === promt)[0].imageId = id;
                                        return newMembers;
                                    });
                                }} />
                                // ''
                                 : '' }
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <div><b>{object.name}</b> - {object.description}</div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Button className='delete' color='red' icon size='mini' onClick={e => {e.stopPropagation(); setObjects(objects => objects.filter(x => x.id !== object.id))}}><Icon name='trash'/> Удалить</Button>
                </div>
            })}
            <Button disabled={isInventing} onClick={() => setOpenCreateUpdateModal(true)} icon fluid ><Icon name='plus'/> Добавить предмет</Button>
            <Button disabled={objects.length === 0 || isInventing} fluid primary size='huge' icon onClick={() => setStep(StepType.End)}><Icon name='star outline'/> Создать проект</Button>
        </div>
        <CreateUpdateObjectModal
            open={openCreateUpdateModal} 
            setOpen={setOpenCreateUpdateModal} 
            object={createUpdateModalObject} 
            onSave={object => {
                if(createUpdateModalObject === undefined){
                    setObjects([...objects, object]);
                }else{
                    setObjects(objects => {
                        return objects.map(x => x.id === object.id ? object : x);
                    });
                }
                setCreateUpdateModalObject(undefined);
            }}
            />
    </>;
}
  
export default ObjectsStep;
  